import hoverManager from './HoverManager';
import platformDetection from './PlatformDetection'

const helpUtils = {
    initialTitleChecked: false,
    titleAlertVisible: false,
    closeTitleAlert: undefined,

    showHelpInfo: true,
    isAdded: false,

    checkHelpInfo() {
        if (this.showHelpInfo && !this.isAdded) {
            setTimeout(this.addHelpInfo.bind(this), 100);
        }
    },
    addHelpInfo() {
        this.isAdded = true;
        var target = document.getElementById('helpButton');

        if (target)
            hoverManager.showHelpInfo(target, 'helpButton');

        if (platformDetection.isIOS() == true) {
            window.addEventListener('touchstart', this.onMouseDown.bind(this));
        } else {
            window.addEventListener('mousedown', this.onMouseDown.bind(this));
        }
    },
    onMouseDown() {
        if (!this.showHelpInfo)
            return;

        hoverManager.hide();
        this.showHelpInfo = false;

        if (platformDetection.isIOS() == true) {
            window.removeEventListener('touchstart', this.onMouseDown);
        } else {
            window.removeEventListener('mousedown', this.onMouseDown);
        }
    }
};

export default helpUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/HelpUtils.js
 **/